import { booleanPointInPolygon, point } from '@turf/turf'

export const getAreaFromLatLngBound = latLngBound => {
  const NE = latLngBound.getNorthEast()
  const SW = latLngBound.getSouthWest()

  const latitudeNE = NE.lat()
  const longitudeNE = NE.lng()
  const latitudeSW = SW.lat()
  const longitudeSW = SW.lng()

  return [
    {
      latitude: latitudeNE,
      longitude: longitudeNE,
    },
    {
      latitude: latitudeNE,
      longitude: longitudeSW,
    },
    {
      latitude: latitudeSW,
      longitude: longitudeSW,
    },
    {
      latitude: latitudeSW,
      longitude: longitudeNE,
    },
  ]
}

export const getFormatedArea = async latLngBound => {
  const rawArea = getAreaFromLatLngBound(latLngBound)
  const formattedArea = {
    type: 'Polygon',
    coordinates: [
      [
        ...rawArea.map(({ longitude, latitude }) => [longitude, latitude]),
        [rawArea[0].longitude, rawArea[0].latitude],
      ],
    ],
  }
  return formattedArea
}

export const isPointInside = ({ turfPolygon, longitude, latitude }) => {
  const turfPoint = point([longitude, latitude])

  return booleanPointInPolygon(turfPoint, turfPolygon)
}
